export default (API) => ({
	//获取区域
	findRegion(params) {
		return API({
			url: `/saas/v1/WhpBranch/findRegion`,
			params,
		})
	},
})
